import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import ReceiptDetailsStyles from "./ReceiptDetailsStyles";

type ReceiptDetailsProps = {
  previewData: any;
  showAccountDetails?: boolean;
};

const ReceiptDetails: React.FC<ReceiptDetailsProps> = ({
  previewData,
  showAccountDetails = false,
}) => {
  const customer = previewData?.customer || {};
  const org = previewData?.org || {};
  const bank = previewData?.bank || {};

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {!showAccountDetails ? (
            <>
              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cellWithRightBorder}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpan as React.CSSProperties
                    }
                  >
                    CIN:
                  </span>
                  {org.cin ?? "—"}
                </TableCell>
                <TableCell sx={ReceiptDetailsStyles.cell}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpan as React.CSSProperties
                    }
                  >
                    Credit Note No. :
                  </span>
                  {previewData?.creditNoteNo ?? "—"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cellWithRightBorderOnly}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpan as React.CSSProperties
                    }
                  >
                    PAN:
                  </span>
                  {org.pan ?? "—"}
                </TableCell>
                <TableCell sx={ReceiptDetailsStyles.cell}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpan as React.CSSProperties
                    }
                  >
                    Date :
                  </span>
                  {previewData?.date ?? "—"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cellWithRightBorderOnly}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpan as React.CSSProperties
                    }
                  >
                    GST:
                  </span>
                  {org.gst ?? "—"}
                </TableCell>
                <TableCell rowSpan={2} sx={{ border: "0" }}></TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cellWithRightBorderOnly}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpan as React.CSSProperties
                    }
                  >
                    GST State Code:
                  </span>
                  {org.gstStateCode ?? "—"}
                </TableCell>
              </TableRow>

              {/* BILL TO / CLIENT DETAILS */}
              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cellBorderAllLeftRight}>
                  BILL TO:
                </TableCell>
                <TableCell sx={ReceiptDetailsStyles.cellBorderAllRight}>
                  CLIENT DETAILS:
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell rowSpan={4} sx={ReceiptDetailsStyles.rowSpanCell}>
                  {customer?.registeredAddress ?? "—"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cell}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpan as React.CSSProperties
                    }
                  >
                    PAN:
                  </span>
                  {customer?.pan ?? "—"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cell}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpan as React.CSSProperties
                    }
                  >
                    GST:
                  </span>
                  {customer?.gst ?? "—"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cell}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpan as React.CSSProperties
                    }
                  >
                    GST State Code:
                  </span>
                  {customer?.gstStateCode ?? "—"}
                </TableCell>
              </TableRow>
            </>
          ) : (
            <>
              {/* ACCOUNT DETAILS */}
              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cell}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpanBold as React.CSSProperties
                    }
                  >
                    Account Name:
                  </span>
                  {bank.accountName ?? "—"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cell}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpanBold as React.CSSProperties
                    }
                  >
                    Account Number:
                  </span>
                  {bank.accountNumber ?? "—"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cell}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpanBold as React.CSSProperties
                    }
                  >
                    Bank Name:
                  </span>
                  {bank.name ?? "—"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cell}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpanBold as React.CSSProperties
                    }
                  >
                    Branch Code:
                  </span>
                  {bank.branchCode ?? "—"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={ReceiptDetailsStyles.cell}>
                  <span
                    style={
                      ReceiptDetailsStyles.labelSpanBold as React.CSSProperties
                    }
                  >
                    IFSC:
                  </span>
                  {bank.ifscCode ?? "—"}
                </TableCell>
              </TableRow>
            </>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReceiptDetails;
